import { render, staticRenderFns } from "./LogisticTraceabilitySamples.vue?vue&type=template&id=417e8f17&scoped=true"
import script from "./LogisticTraceabilitySamples.vue?vue&type=script&lang=js"
export * from "./LogisticTraceabilitySamples.vue?vue&type=script&lang=js"
import style0 from "./LogisticTraceabilitySamples.vue?vue&type=style&index=0&id=417e8f17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417e8f17",
  null
  
)

export default component.exports